import React from 'react';

import PropTypes from 'prop-types';
import i18n from 'i18n-js';
import Layout from 'components/Layout';
import { useParams } from 'react-router-dom';
import Container from '@mui/material/Container';
import { InvoicePreview } from 'components/Invoice';

const InvoicePage = (props) => {
  const { isBill } = props;
  const { id } = useParams();

  return (
    <Layout title={isBill ? i18n.t('bill.title') : i18n.t('invoice.title')}>
      <Container sx={{ minWidth: '100%', margin: 0 }}>
        <InvoicePreview id={id} {...props} />
      </Container>
    </Layout>
  );
};

InvoicePage.propTypes = {
  isBill: PropTypes.bool,
};

export { InvoicePage };
